<ng-container *transloco="let t">
  <div
    class="list-item"
    [class.error]="error()"
    [ngClass]="readOnlyState() ? 'readonly' : ''"
  >
    <div class="header-container">
      @if (!readOnlyState()) {
        <div class="list-actions">
          @if (showToggler() && !isMobile()) {
            <lib-toggle
              [textActive]="togglerTextActive()"
              [textInactive]="togglerTextInactive()"
              [(active)]="togglerValue"
              (change)="toggled()"
            ></lib-toggle>
          }
          @if (!editMode && showMoreVisible()) {
            <button
              vinnova-button-text
              [disabled]="disabled()"
              size="small"
              type="button"
              (click)="onShowMore()"
              [attr.aria-label]="
                title() ? t('list_item_show_more') + ' ' + title() : undefined
              "
            >
              <lib-icon name="eye"></lib-icon
              ><span>{{ t('list_item_show_more') }}</span>
            </button>
          }
          @if (!editMode && editVisible() && !isMobile()) {
            <button
              vinnova-button-text
              [disabled]="disabled()"
              size="small"
              type="button"
              (click)="toggleEdit()"
              [attr.aria-label]="
                title() ? t('list_item_edit') + ' ' + title() : undefined
              "
            >
              <lib-icon name="edit-2"></lib-icon
              ><span>{{ t('list_item_edit') }}</span>
            </button>
          }
          @if (
            !showToggler() &&
            ((removeVisible() && !editMode) ||
              (onlyEditMode() && removeVisible())) &&
            !hideClose() &&
            !isMobile()
          ) {
            <button
              vinnova-button-text
              [disabled]="disabled()"
              size="small"
              type="button"
              (click)="onRemove()"
              [attr.aria-label]="
                title() ? t('list_item_remove') + ' ' + title() : undefined
              "
            >
              <lib-icon name="trash"></lib-icon
              ><span>{{ t('list_item_remove') }}</span>
            </button>
          }
          @if (editMode && !onlyEditMode() && !hideClose() && !isMobile()) {
            <button
              vinnova-button-text
              [disabled]="disabled()"
              size="small"
              type="button"
              (click)="toggleEdit()"
              [attr.aria-label]="
                title() ? t('list_item_close') + ' ' + title() : undefined
              "
            >
              <lib-icon name="x"></lib-icon
              ><span>{{ t('list_item_close') }}</span>
            </button>
          }
        </div>
      }
      @if (editMode) {
        <ng-content select="[edit-title]"></ng-content>
      } @else {
        <ng-content select="[view-title]"></ng-content>
      }
    </div>

    <div class="list-item-container">
      <div class="list-item-content">
        @if (editMode) {
          <ng-content select="[edit]"></ng-content>
        } @else {
          <ng-content select="[view]"></ng-content>
        }
        @if (!editMode && showMore) {
          <ng-content select="[showMore]"></ng-content>
        }
      </div>
      @if (!readOnlyState()) {
        @if (showToggler() && isMobile()) {
          <lib-toggle
            class="isMobile-toggle"
            [textActive]="togglerTextActive()"
            [textInactive]="togglerTextInactive()"
            [(active)]="togglerValue"
            (change)="toggled()"
          ></lib-toggle>
        }
        @if (
          !showToggler() &&
          ((removeVisible() && !editMode) ||
            (onlyEditMode() && removeVisible())) &&
          !hideClose() &&
          isMobile()
        ) {
          <button
            vinnova-button-text
            [disabled]="disabled()"
            size="small"
            type="button"
            (click)="onRemove()"
            [attr.aria-label]="
              title() ? t('list_item_remove') + ' ' + title() : undefined
            "
          >
            <lib-icon name="trash"></lib-icon
            ><span>{{ t('list_item_remove') }}</span>
          </button>
        }
        @if (!editMode && editVisible() && isMobile()) {
          <button
            vinnova-button-text
            [disabled]="disabled()"
            size="small"
            type="button"
            (click)="toggleEdit()"
            [attr.aria-label]="
              title() ? t('list_item_edit') + ' ' + title() : undefined
            "
          >
            <lib-icon name="edit-2"></lib-icon
            ><span>{{ t('list_item_edit') }}</span>
          </button>
        }
      }
      @if (!readOnlyState()) {
        <div class="mt-auto">
          @if (actionVisible() && !actionCheckbox()) {
            <button
              vinnova-button-text
              size="small"
              type="button"
              (click)="onAction()"
            >
              {{ actionText() }}
            </button>
          } @else if (actionVisible() && actionCheckbox()) {
            <lib-vinnova-checkboxes
              [checkboxObjects]="[{ id: 0, label: actionText() }]"
              [disabled]="true"
              singleCheckbox="true"
              [horizontal]="true"
            >
            </lib-vinnova-checkboxes>
          }
        </div>
      }
    </div>
  </div>
</ng-container>
